const configpath = {
  // apiUrl: "http://localhost:8000/api", // local env
  apiUrl: "https://test.ensaras.com/api", // test env
  // apiUrl: 'https://portal.ensaras.com/api', // prod env
  grafanaUrl: "https://test.ensaras.com/grafana/nanded-mbr",
};

export default configpath;
